export const VAD_THRESHOLD_MAX = 0.98;
export const WAITING_TIME_MAX = 5000;
export const WAITING_TIME_WARNING_THRESHOLD = 2000;

// Energy gate (background-voice suppression) tuning
export const ENERGY_GATE_THRESHOLD_DB_MIN = 3;
export const ENERGY_GATE_THRESHOLD_DB_MAX = 20;
export const ENERGY_GATE_THRESHOLD_DB_DEFAULT = 10;
// Mirrors the VAD server's energy_margin_db default (12), which we don't override
export const ENERGY_MARGIN_DB = 12;
// dBFS meter scale for the energy-gate visualization.
// The server clamps RMS at -90 dBFS, but anything below ~-70 dBFS is effectively
// silence, so the meter starts there to give the useful range more room.
export const ENERGY_METER_MIN_DBFS = -70;
export const ENERGY_METER_MAX_DBFS = 0;
